/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    unitBase, rowSpacing, enterpriseCSS,
} from './variables';

import { StatusTrackingBar } from './common/StatusTrackingBar';

export const OrderDetailsStyle = (typography, palette, breakpoints, brand) => {

    return {
        OrderDetailsStyle: {
            '& .bottom-border': {
                borderBottom: `1px solid ${enterpriseCSS.palette.gray3}`,
            },
            '& .dark-border': {
                borderBottom: `1px solid ${enterpriseCSS.palette.gray2}`,
                borderTop: `1px solid ${enterpriseCSS.palette.gray2}`,
            },
            '& .toggle-product-button': {
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                padding: '15px 0',
                color: enterpriseCSS.palette.blue,
                cursor: 'pointer',
                '& img': {
                    marginLeft: '10px',
                },
            },
            // desktop Order Detail
            '& .desktop-view': {
                maxWidth: '1440px',
                width: '100%',
                margin: 'auto',
                '& .history-container': {
                    padding: '25px',
                    '& .history-update': {
                        height: '40px',
                        overflowY: 'hidden',
                        '& .history-img-container': {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginRight: '10px',
                            //  '& .line-img': {
                            //      height: '30px',
                            //  },
                        },
                        ' & p': {
                            textTransform: 'capitalize',
                        },
                    },
                },
                '& .margin-right-0': {
                    marginRight: 0,
                },
                '& .order-detail-guest': {
                    margin: '0 auto',
                },
                '& .delivery-info': {
                    borderRadius: '0px',
                },
                '& .width': {
                    width: '100%',
                },
                '& .padding-zero': {
                    padding: '0px',
                },
                '& .padding-10': {
                    padding: '10px',
                },
                '& .dekstop-order-details-title': {
                    marginBottom: rowSpacing * 2,
                },
                '& .top-button-wrapper': {
                    marginBottom: rowSpacing * 2,
                    textAlign: 'right',
                },
                '& .desktop-item-detail': {
                    padding: '0px',
                    '& .desktop-status-bar': {
                        padding: rowSpacing * 2,
                        '& .statusTrackingBar': {
                            margin: '0px !important',
                        },
                        '& .link': {
                            cursor: 'pointer',
                        },
                        '& .subStatusContainer': {
                            display: 'flex',
                            alignItems: 'center',
                            '& *': {
                                fontSize: '16px',
                            },
                        },
                        '& .delay-container': {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'left',
                            '& img': {
                                marginRight: '5px',
                            },
                        },
                        '& .fedex-logo': {
                            marginLeft: '5px',
                        },
                        '& .orderDetail': {
                            textAlign: 'left',
                        },
                    },
                    '& .alignColumn': {
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'self-start',
                    },
                    '& .alignCenter': {
                        alignItems: 'center',
                    },
                    '& .hidden': {
                        height: 0,
                    },
                    '& .desktop-shipping': {
                        padding: rowSpacing * 2,
                        '& .desktop-modify-error': {
                            margin: '70px 70px 0 0',
                            padding: '7.5px',
                             color: `${enterpriseCSS.palette.error} !important`,
                        },
                        '& .desktop-modify-error-donation': {
                            padding: '12px',
                        },
                        '& .inline-modify-error': {
                            marginTop: 0,
                        },
                        '& .min-height-100': {
                            minHeight: '100px',
                        },
                        '& .border-radius-zero': {
                            borderRadius: '0px',
                        },
                        '& .margin-top-bottom-10': {
                            margin: '10px 0px',
                        },
                        '& .margin-top': {
                            marginTop: '20px !important',
                        },
                        '& .desktop-gift-message-container': {
                            wordBreak: 'break-word',
                        },
                    },
                    '& .desktop-product-detail': {
                        display: 'flex',
                        'align-items': 'stretch',

                        '& .product-image': {
                            flex: 'none',
                            marginRight: `${unitBase * 2}px`,
                            '& img': {
                                maxWidth: '100px',
                                minWidth: '100px',
                            },
                        },
                    },
                    '& .desktop-product-container': {
                        padding: rowSpacing * 2,
                        borderBottom: `1px dashed ${enterpriseCSS.palette.gray3}`,
                        '&:last-child': {
                            borderBottom: 'none',
                        },
                        '& .reservebar-contact-info': {
                           whiteSpace: 'nowrap',
                           marginTop: '4rem',
                           '& a': {
                              color: '#000000',
                           }
                        },
                    },
                    '& .replace-cancel-container': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'space-around',
                    },
                    '& .price-qty-container': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        '& .price-qty-inner-container': {
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'flex-start',
                           marginLeft: '70%',
                        },
                     },
                     ' & .align-self-start': {
                           alignSelf: 'flex-start',
                     },
                    ' & .replacement-already-found-container': {
                        ' & p': {
                            margin: 0,
                        },
                        ' & div': {
                            cursor: 'pointer',
                            color: `${enterpriseCSS.palette.blue}`,
                            textDecoration: 'underline',
                            fontWeight: '500'
                        },
                    },
                    '& .product-description': {
                        position: 'relative',

                        '& .product-name': {
                            marginBottom: rowSpacing,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            '-webkit-line-clamp': 2,
                            '-webkit-box-orient': 'vertical',
                            '& a': {
                                color: `${enterpriseCSS.palette.blue}`,
                            },
                        },

                        '& .subscription': {
                            '& .subscription-delivery': {
                                display: 'block',
                            },
                        },

                        '& .product-sku': {
                            position: 'absolute',
                            bottom: 0,
                        },

                        '& .product-brand': {
                            position: 'absolute',
                            top: '40px',
                        },
                    },

                },
                '& .desktop-card-title': {
                    backgroundColor: `${enterpriseCSS.palette.gray3}`,
                },
                '& .margin-right-10': {
                    marginRight: '10px',
                },
                '& .margin-left-10': {
                    marginLeft: '10px',
                },
                '& .bottom-modify-card': {
                    minHeight: '175px',
                    borderRadius: '0px',
                    '& ul': {
                        paddingLeft: '26px',
                    },
                },
                '& .replace-button-container': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                },
                '& .replace-button': {
                    backgroundColor: enterpriseCSS.palette.button.accountCallToAction[brand],
                    // color: enterpriseCSS.palette.button.darkGray,
                    fontWeight: 'normal',
                    width: '200px',
                    padding: '8px 15px !important',
                },
                '& .payment-method-container': {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                },
                '& .cancel-button-container': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    marginTop: '3vh',
                },
                '& .cta-button': {
                    backgroundColor: enterpriseCSS.palette.button.accountCallToAction[brand],
                    color: enterpriseCSS.palette.white,
                    border: '1px solid',
                    fontWeight: '600',
                    margin: 0,
                },
                '& .orderTwo': {
                    order: 2,
                },
            },
            '& .hidden': {
                display: 'none',
            },
            // Order Details
            '& .negative-margin': {
                margin: '-16px',
            },
            '& .mobile-view': {
                '& .modify-button-container': {
                    position: 'relative',
                },
                '& .modify-button': {
                    position: 'absolute',
                    top: '15px',
                    left: '61.5%',
                    minWidth: '115px',
                    width: '115px',
                    height: '28px',
                },
                '& .cta-button': {
                    float: 'none',
                    fontSize: '14px',
                    backgroundColor: enterpriseCSS.palette.button.accountCallToAction[brand],
                    color: enterpriseCSS.palette.white,
                    border: '1px solid',
                    borderRadius: '50px',
                    fontWeight: '600',
                    lineHeight: '18px',
                    padding: '8px 10px',
                    margin: '10px 0px 12px 10px',
                },
                '& .replacement-v2-container': {
                  display: 'flex',
                  justifyContent: 'center',
                },
                '& .replacement-v2-cta-button': {
                    float: 'none',
                    fontSize: '14px',
                    backgroundColor: enterpriseCSS.palette.button.accountCallToAction[brand],
                    color: enterpriseCSS.palette.white,
                    border: '1px solid',
                    borderRadius: '50px',
                    fontWeight: '600',
                    lineHeight: '18px',
                    padding: '12px 20px',
                    margin: '10px 0px 12px 0px',
                },
                '& .toggle-product-button': {
                    padding: 0,
                    '& img[alt=collapse]': {
                        width: 15,
                    },
                },
                '& .history-container': {
                    padding: '20px 0',

                    '& .history-update': {
                        height: '75px',
                        overflowY: 'hidden',

                        '& .history-img-container': {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginRight: '10px',
                        },
                        '& .history-description': {
                            marginTop: -3,
                            '& p': {
                                textTransform: 'capitalize',
                                margin: 0,
                                '&:not(.bold)': {
                                    color: `${enterpriseCSS.palette.gray1}`,
                                    fontSize: '12px',
                                },
                            },
                        },
                    },
                },
                '& .gift-message-container': {
                  wordBreak: 'break-all',
                },
                '& .delivery-details': {
                    display: 'flex',
                    flexDirection: 'column',
                },
                '& .mobile-reservebar-contact-info': {
                  '& a': {
                     color: '#000000',
                     whiteSpace: 'nowrap'
                  },
               },
            },
            '& .ross-mobile-order-header-with-cancel': {
                margin: '0 -12px',
                backgroundColor: `${enterpriseCSS.palette.gray3}`,
                marginTop: '-24px',
                padding: '12px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                borderBottom: `1px solid ${enterpriseCSS.palette.gray2}`,
                '& .ross-order-info-wrap': {
                    flexFlow: 'column',
                    flex: 'auto',
                    display: 'flex',
                },
                '& .ross-order-info': {
                    padding: '5px 0',
                    float: 'left',
                    whiteSpace: 'nowrap',
                },
                '& .backButtonWrap': {
                    minWidth: '40px',
                    [breakpoints.down('xs')]: {
                        minWidth: '26px',
                    },
                },
                '& .ROSS-back-button': {
                    position: 'absolute',
                    transform: 'translate(0, -50%)',
                    top: '50%',
                    left: 0,
                    [breakpoints.down('xs')]: {
                        left: '-13px',
                    },
                },
                '& .cancel-button': {
                    padding: '6px 16px !important',
                },
            },
            '& .ross-mobile-order-header-no-cancel': {
                margin: '0 -12px',
                backgroundColor: `${enterpriseCSS.palette.gray3}`,
                marginTop: '-24px',
                padding: '12px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                borderBottom: `1px solid ${enterpriseCSS.palette.gray2}`,
                '& .ross-order-info': {
                    padding: '5px 0',
                },
                '& button': {
                    position: 'absolute',
                    transform: 'translate(0, -50%)',
                    top: '50%',
                    left: 0,
                },
            },

            '& .fullwidth-error': {
                margin: '16px -16px',
                padding: '12px 0',
            },
            '& .fullwidth-error-top-margin': {
               padding: '12px 0',
            },
            '& .orderDetail': {
                textAlign: 'center',
            },
            '& .order-info': {
                paddingTop: rowSpacing,
                marginTop: rowSpacing,
                width: '100%',
                '& > *': {
                    marginBottom: rowSpacing,
                },
            },
            '& .orderDetail-tracker-flex-column-start': {
               display: 'flex',
               flexDirection: 'column',
               alignItems: 'flex-start',
            },
            '& .order-info-delivery-popup': {
                position: 'relative',
                width: 70,
                top: -30,
            },
            '& .delivery-info': {
                boxShadow: '0px 0px 10px rgb(47 47 47 / 25%)',
                marginBottom: '12px',
                '& hr': {
                    backgroundColor: enterpriseCSS.palette.gray3,
                    margin: `${rowSpacing}px -${rowSpacing}px`,
                },
                '& .mobile-billing-addr-container': {
                    display: 'flex',
                    justifyContent: 'space-between',
                },
                '& .delay-container': {
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '5px',
                    '& img': {
                        marginRight: '5px',
                    },
                },
                '& .delivery-info-no-padding-top': {
                  padding: '0px 16px 16px 16px',
                },
                '& .product-detail': {
                    borderBottom: `1px dashed ${enterpriseCSS.palette.gray3}`,
                    margin: `${rowSpacing}px -${rowSpacing}px`,
                    padding: `0 ${rowSpacing}px`,
                    '&.last': {
                        borderBottom: 'none',
                        marginBottom: 0,
                    },
                    '& .product-image': {
                        minWidth: `${unitBase * 16}px`,
                        flex: 2,
                        display: 'flex',
                        marginRight: 0,
                        '& img': {
                            marginRight: `${unitBase * 2}px`,
                            maxWidth: '85px',
                            maxHeight: '93px',
                        },
                        '& .name-sku-container': {
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                        },
                        '& .product-name': {
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            '-webkit-box-orient': 'vertical',
                            display: '-webkit-box',
                            '-webkit-line-clamp': 2,
                            height: 'calc(2em + 10px)',
                            '& a': {
                                color: `${enterpriseCSS.palette.blue}`,
                            },
                        },
                    },
                    '& .product-description': {
                        '& .price-label': {
                            display: 'inline-block',
                            paddingRight: unitBase,
                            // width: `${unitBase * 10}px`,
                            textAlign: 'right',
                        },
                        '& .replace-button': {
                            backgroundColor: enterpriseCSS.palette.button.accountCallToAction[brand],
                            color: enterpriseCSS.palette.white,
                            fontWeight: 'normal',
                            borderRadius: '50px',
                            fontSize: '14px',
                            lineHeight: '18px',
                            marginBottom: `${unitBase * 2}px`,
                            padding: '8px',
                            whiteSpace: 'nowrap',
                        },
                        '& .cancel-button-container': {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            marginBottom: '10px',
                            bottom: '0px',
                        },
                    },
                    '& .price-qty-bottom': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    },
                    // '& .product-price': {
                    //     width: `${unitBase * 25}px`,
                    //     flex: 'none',
                    // },
                },
                '& .summary-info': {
                    '& .split': {
                        lineHeight: '20px',
                        letterSpacing: '0.28px',
                        margin: `${unitBase}px 0`,
                        '&:last-child': {
                            // borderTop: '1px solid black',
                            fontWeight: 'bold',
                            paddingTop: unitBase,
                        },
                        '& .green-font': {
                            color: '#058942',
                        },
                        '& .bold-font': {
                            fontWeight: 700,
                        },
                    },
                    '& .summary-price': {
                        width: `${unitBase * 16}px`,
                        flex: 'none',
                        textAlign: 'right',
                    },
                },
            },
            '& .card-info': {
                position: 'relative',
                boxShadow: '0px 0px 10px rgb(47 47 47 / 25%)',
                '& .card-title': {
                    backgroundColor: enterpriseCSS.palette.gray3,
                    padding: rowSpacing,
                    margin: `-${rowSpacing}px -${rowSpacing}px ${rowSpacing}px -${rowSpacing}px`,
                },

                '& ul': {
                    paddingLeft: `${rowSpacing + unitBase}px`,
                },
            },
            '& .orderListHeader': {
                background: enterpriseCSS.palette.gray3,
                padding: '10px 5px',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',

                '& button': {
                    minWidth: 'auto',
                    padding: '6px 12px',
                },
            },
            '& .toggle-guest-billing-button': {
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                padding: '15px 0',
                color: enterpriseCSS.palette.blue,
                cursor: 'pointer',
                '& img': {
                    marginLeft: '10px',
                },
            },
            '& .desktop-billing-guest': {
                padding: '3em',
                '& span': {
                    color: `${enterpriseCSS.palette.blue}`,
                    cursor: 'pointer',
                },
                '& p': {
                    marginBottom: 0,
                },
            },
            '& .mobile-billing-guest': {
                justifyContent: 'center',
                padding: '0.6em',
                fontSize: '14px',
                '& span': {
                    color: `${enterpriseCSS.palette.blue}`,
                    cursor: 'pointer',
                },
                '& p': {
                    marginBottom: 0,
                    fontSize: '14px',
                },
            },
            '& .card-content-padding': {
                padding: '10px 5px',
            },

            ...StatusTrackingBar(typography, palette).StatusTrackingBar,
        },
    };
};
